import {
  replaceTokensInString,
  replaceTokensWithComponents
} from '@cat-ecom/common/utils/stringUtils';
import { CatTextLink } from 'components/blocks-components';

export const CAT_FINANCIAL_SUMMARY_LINK =
  'https://catfinancial--{0}.sandbox.my.site.com/mycatfinancial/services/auth/sso/MyCatfinancial_B2C_non_prod?startURL=/s/gc-RR-Summary?show=GC_RR_RewardsReimaginedSummary';

export const CAT_FINANCIAL_SUMMARY_LINK_FOR_DEVS = replaceTokensInString(
  CAT_FINANCIAL_SUMMARY_LINK,
  'sit'
);

export const CAT_FINANCIAL_SUMMARY_LINK_FOR_NON_PRODUCTION =
  replaceTokensInString(CAT_FINANCIAL_SUMMARY_LINK, 'train');

export const CAT_FINANCIAL_SUMMARY_LINK_FOR_PRODUCTION =
  'https://mycatfinancial.com/services/auth/sso/MyCatfinancial_B2C?startURL=/s/gc-RR-Summary?show=GC_RR_RewardsReimaginedSummary';

export const ENROLLED_CAT_VANTAGE_REWARDS_STAR =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20231214-7f82d-8062b';
export const NOT_ENROLLED_CAT_VANTAGE_REWARDS_STAR =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20231214-01efc-d1700';

export const CAT_VANTAGE_REWARDS_STAR = {
  size: 32,
  description: 'Cat Vantage Rewards Star',
  sizeMedium: 24,
  sizeSmall: 16,
  sizeIntermediate: 20
};

const CVRLabel = 'Cat{0} Vantage Rewards';

export const tradeMarkSymbol = '®';

const superscriptOfRegisteredTrademarkSymbol = <sup>®</sup>;

export const catVantageRewardCopyright = replaceTokensWithComponents(
  CVRLabel,
  superscriptOfRegisteredTrademarkSymbol
);

export const catVantageRewardCopyrightString = replaceTokensInString(
  CVRLabel,
  tradeMarkSymbol
);

export const catCreditsCopyrightString = replaceTokensInString(
  'Cat{0} Credits',
  tradeMarkSymbol
);

export const MINIMUM_CVR_TO_SHOW = 50;

export const CVR_ENROLLED_IMG =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20240212-77a19-f6908';

export const CVR_NOT_ENROLLED_IMG =
  'https://s7d2.scene7.com/is/content/Caterpillar/CM20240212-c5944-37e9e';

export const catVantageRewards = (
  <span translate="no">{' Cat Vantage Rewards '}</span>
);

export const phoneNumberLink = (
  <CatTextLink size="sm">1-877-373-9567</CatTextLink>
);

export const learnMoreLink = 'https://www.cat.com/getrewarded';

export const termsAndConditionsLink =
  'https://www.cat.com/en_US/support/catvantage-rewards/legal.html#accordion-bb70cbce03-item-a56c0d7ad4-butto';

export const ENROLL_FORM_ID = 'enroll-form';
